/**
 * @Author: v_jppjpeng
 * @Date: 2024-12-02 09:53:39
 * @Explain: 自动化活动
 */

export default {
  // 列表
  'ACTIVITY.AUTO.WELCOME.TITLE': 'Welcome new contacts',
  'ACTIVITY.AUTO.WELCOME.DESC':
    'Set up automated campaigns that send an attentive welcome email to new contacts who are added to SmartLink from different sources.',
  'ACTIVITY.AUTO.LIST': 'Automated campaigns',
  'ACTIVITY.AUTO.LIST.START.CREATE': 'Create',
  'ACTIVITY.AUTO.LIST.CREATE.AUTO.JOURNEY': 'Create automation',
  'ACTIVITY.AUTO.LIST.JOURNEY.NAME': 'Journey name',
  'ACTIVITY.AUTO.LIST.JOURNEY.NAME.PLACEHOLDER': 'Enter journey name',
  'ACTIVITY.AUTO.LIST.TITLE': 'Automations list',
  'ACTIVITY.AUTO.LIST.NAME': 'Name',
  'ACTIVITY.AUTO.LIST.CONTACTS.SENT.NUMBER': 'Number of recipients',
  'ACTIVITY.AUTO.LIST.TIME': 'Activated on',
  'ACTIVITY.AUTO.LIST.UPDATER': 'Last updated by',
  'ACTIVITY.AUTO.LIST.STATUS': 'Status',
  'ACTIVITY.AUTO.LIST.STATUS.BUBBLE.TITLE': 'Suspension details',
  'ACTIVITY.AUTO.LIST.STATUS.BUBBLE.DESC.1.1':
    '<span style="color: #fff; opacity: 0.8">Suspension time: </span> {suspensionDays} day(s)',
  'ACTIVITY.AUTO.LIST.STATUS.BUBBLE.DESC.1.2':
    '<span style="color: #fff; opacity: 0.8">Suspension time: </span> {suspensionHours} hour(s)',
  'ACTIVITY.AUTO.LIST.STATUS.BUBBLE.DESC.1.3':
    '<span style="color: #fff; opacity: 0.8">Suspension time: </span> {suspensionDays} day(s) {suspensionHours} hour(s)',
  'ACTIVITY.AUTO.LIST.STATUS.BUBBLE.DESC.2':
    '<span style="color: #fff; opacity: 0.8">Accumulated: </span> {num}',
  'ACTIVITY.AUTO.LIST.STATUS.ONGOING': 'Ongoing',
  'ACTIVITY.AUTO.LIST.STATUS.NOT.ACTIVITE': 'Inactive',
  'ACTIVITY.AUTO.LIST.STATUS.SUSPENDED': 'Suspended',
  'ACTIVITY.AUTO.LIST.STATUS.TERMINATED': 'Terminated',
  'ACTIVITY.AUTO.LIST.ACTION.DETAILS': 'Details',
  'ACTIVITY.AUTO.LIST.ACTION.REVISE.ERROR': 'Revise error',
  'ACTIVITY.AUTO.LIST.SUSPEND.TITLE': 'Suspend automation',
  'ACTIVITY.AUTO.LIST.SUSPEND.DESC':
    '<div class="color-666"><p>After suspending an automation, you can modify its configurations. Afterwards it can be restarted and send emails according to these new configurations.</p><p style="padding-top: 16px">A suspended automation will not send out emails to contacts, so make sure to enable it as soon as possible.</p></div>',
  'ACTIVITY.AUTO.LIST.START.TITLE': 'Restart automation',
  'ACTIVITY.AUTO.LIST.START.DESC':
    "<div class='color-666'><p>Restarting will activate the newest configurations.</p><p style='padding-top: 16px'>This automation was suspended for {suspendSecond} hours and {contactsBacklog} contacts were accumulated during this suspension. Enable the toggle below to send emails to these accumulated contacts according to the configurations of this automation before any adjustments.</p></div>",
  'ACTIVITY.AUTO.LIST.START.ACTIVATE': 'Send emails to accumulated contacts',
  'ACTIVITY.AUTO.LIST.DEL.TITLE': 'Delete automation',
  'ACTIVITY.AUTO.LIST.DEL.DESC':
    "Automation <b class='color-333'>'<span>{name}</span>'</b> will be permanently deleted and cannot be restored.",
  'ACTIVITY.AUTO.LIST.STOP.TITLE': 'Automation termination',
  'ACTIVITY.AUTO.LIST.STOP.DESC':
    "<div><p>Automation <b class='color-333'>'<span>{name}</span>'</b> will be permanently deleted and cannot be restored.</p><p style='padding-top: 16px'>If you need to modify its configurations, you can suspend the automation and restart it afterwards.</p><div>",

  // 创建、编辑
  'ACTIVITY.AUTO.SAVE.ACTIVATE': 'Save and activate automation',
  'ACTIVITY.AUTO.JOURNEY.IS': '<span class="mr-5">Automation is</span>',
  'ACTIVITY.AUTO.PLEASE.CHECK': 'Please check this',
  'ACTIVITY.AUTO.CHECK.JOURNEY.CONFIG':
    "<span class='ml-5'>automation's configurations</span>",
  'ACTIVITY.AUTO.CLICK.START.SETTING': 'Start setting up your automation',
  'ACTIVITY.AUTO.CONTACTS.SOURCE': 'Contact source',
  'ACTIVITY.AUTO.CONTACTS.SOURCE.TIPS': 'Select the contact source.',
  'ACTIVITY.AUTO.CONTACT.SOURCE.HSA.BEEN.SET':
    'Contact source set up successfully',
  'ACTIVITY.AUTO.DOUBLE.OPT.IN.SETTING': 'Double opt-in settings',
  'ACTIVITY.AUTO.DOUBLE.OPT.IN.HAVE.SET':
    'Double opt-in email set up successfully',
  'ACTIVITY.AUTO.DOUBLE.OPT.IN.TIPS':
    'Decide if you want to send a confirmation email to contacts who subscribe through this source.',
  'ACTIVITY.AUTO.WELCOME.EMAIL.SETTING': 'Welcome email settings',
  'ACTIVITY.AUTO.WELCOME.EMAIL.HAVE.SET': 'Welcome email set up successfully',
  'ACTIVITY.AUTO.WELCOME.EMAIL.SETTING.TIPS':
    'Decide if you want to send a welcome email to contacts who subscribe through this source.',
  'ACTIVITY.AUTO.WELCOME.EMAIL.NO.SEND.TIPS': 'Not sending welcome email',
  'ACTIVITY.AUTO.WAIT.TIME': 'Wait time',
  'ACTIVITY.AUTO.WAIT.TIME.SETTING.TITLE':
    'Set a time delay before moving forward',
  'ACTIVITY.AUTO.WAIT.TIME.DELAY.FOR': 'Delay for',

  // 编辑 - 联系人来自于
  'ACTIVITY.AUTO.JOURNEY.CONFIGURED.NAME':
    'Already configured in automation "{name}"',
  'ACTIVITY.AUTO.SOURCE.HAS.BEEN.DELETED':
    '<div class="del-name">{name}</div> has been deleted',

  // 表现统计
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE': 'Automation results',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.CONTACT.SOURCE': 'Contact source',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.TOTAL.CONTACT':
    'Total contacts from this source',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.DOUBLE.OPT.IN': 'Double opt-in emails',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.WELCOME.EMAIL': 'Welcome emails',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.SENT': 'Sent',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.DELIVERED': 'Delivered',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.OPENED': 'Opened',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.CONFIRM': 'Confirmed',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.CLICKED': 'Clicked',
  'ACTIVITY.AUTO.JOURNEY.PREFERENCE.UNSUBSCRIBE': 'Unsubscribes',

  // 双重确认订阅设置
  'OPT.IN.SETTINGS.TITLE': 'API and form source settings',
  'OPT.IN.SETTINGS.SINGLE.TITLE': 'Single opt-in',
  'OPT.IN.SETTINGS.SINGLE.DESC':
    "<b>Single opt-in</b> when a player subscribes, their email is directly added to the contacts list with a 'Subscribed' status.",
  'OPT.IN.SETTINGS.DOUBLE.TITLE': 'Double opt-in',
  'OPT.IN.SETTINGS.DOUBLE.DESC1':
    "<b>Double opt-in</b> when a player subscribes, an email is sent to them to confirm their subscription. Only after they confirm, their email will be added to the contacts list with a 'Subscribed' status.",
  'OPT.IN.SETTINGS.DOUBLE.DESC2':
    "The confirmation email is only sent out to new (non-existing) contacts who are added through the API. It's not sent out when updating information of an existing contact.",
  'OPT.IN.SETTINGS.METHOD': 'Choose opt-in setting',
  'OPT.IN.SETTINGS.METHOD.SINGLE.TITLE': 'Single opt-in',
  'OPT.IN.SETTINGS.METHOD.SINGLE.DESC':
    "When a new (non-existing) contact is added through the API or form with a subscribed state, they will have the 'Subscribed' status and can receive emails immediately.",
  'OPT.IN.SETTINGS.METHOD.DOUBLE.PARTICULAR.TITLE':
    'Double opt-in for players from specific regions',
  'OPT.IN.SETTINGS.METHOD.DOUBLE.PARTICULAR.TIPS':
    'Double opt-in is only enabled for countries/regions where it is mandated by law: {country}. ',
  'OPT.IN.SETTINGS.METHOD.DOUBLE.PARTICULAR.TIPS2':
    '(Player region required in advance)',
  'OPT.IN.SETTINGS.METHOD.DOUBLE.PARTICULAR.DESC1':
    'When a new (non-existing) contact from certain regions is added through an API or form with a subscribed status, an email is sent to them to confirm their subscription.',
  'OPT.IN.SETTINGS.METHOD.DOUBLE.PARTICULAR.DESC2':
    "Only after they confirm, their subscription status will change from 'Pending' to 'Subscribed'.",
  'OPT.IN.SETTINGS.METHOD.DOUBLE.ALL.TITLE':
    'Double opt-in for players from all regions',
  'OPT.IN.SETTINGS.METHOD.DOUBLE.ALL.DESC1':
    'When a new (non-existing) contact from any region is added through an API or form with a subscribed status, an email is sent to them to confirm their subscription.',
  'OPT.IN.SETTINGS.METHOD.DOUBLE.ALL.DESC2':
    "Only after they confirm, their subscription status will change from 'Pending' to 'Subscribed'.",
  'OPT.IN.SETTINGS.CONFIRM.EMAIL.SETTINGS':
    'Configure sender information and email content',
  'OPT.IN.SETTINGS.SELECT.DEFAULT.TEMPLATE': 'Use default template',
  'OPT.IN.SETTINGS.SELECT.MARKETING.TEMPLATE':
    'Select marketing email template',
  'OPT.IN.SETTINGS.SENDING.INFO': 'Sender details',
  'OPT.IN.SETTINGS.SUBJECT.LINE': 'Subject line',
  'OPT.IN.SETTINGS.SUBJECT.LINE.PLACEHOLDER': 'Enter subject line',
  'OPT.IN.SETTINGS.SUBJECT.CONFIRM.SUBSCRIPTION':
    'Please Confirm Your Subscription',
  'OPT.IN.SETTINGS.CONTACT.EMAIL': 'Contact email',
  'OPT.IN.SETTINGS.PLEASE.ENTER.CONTACT.EMAIL': 'Please enter a contact email',
  'OPT.IN.SETTINGS.CONTACT.EMAIL.PLACEHOLDER':
    'Enter email address for players to contact you',
  'OPT.IN.SETTINGS.PREVIEW.TITLE': 'Email preview',
  'OPT.IN.SETTINGS.TO.ME': 'to me',
  'OPT.IN.SETTINGS.CONFIRM.SAVE.TIPS':
    'Current content has not been saved. Do you want to save it?',
  'OPT.IN.SETTINGS.TEMPLATE.MISSING.BUILT.IN.LINK.TIPS':
    'A template is missing the confirmation link. Please check the template for: {language}',

  // 欢迎邮件设置
  'ACTIVITY.AUTO.WELCOME.EMAIL.DESC1':
    'The welcome email will be sent after a contact has successfully subscribed to your newsletter. This provides an opportunity for your first meaningful connection with your contact.',
  'ACTIVITY.AUTO.WELCOME.EMAIL.DESC2':
    'Welcome emails are sent out depending on the subscription status of the contact during the automation flow, it does not depend on whether a confirmation email was sent out in the automation flow.',
  'ACTIVITY.AUTO.WELCOME.EMAIL.DESC3':
    "Players who are sent a confirmation email will need to confirm their subscription first, after which their status will change to 'Subscribed'. When their status has changed to 'Subscribed', they will receive the welcome email.",
  'ACTIVITY.AUTO.WELCOME.EMAIL.YES':
    'Contacts from this source are sent a welcome email after subscribing',
  'ACTIVITY.AUTO.WELCOME.EMAIL.NO':
    'Contacts from this source are not sent a welcome email',
};
